import { useNavigate } from "@reach/router";

import { useGlobal } from "kanopi-components/useGlobal";
import { useMatchParams } from "kanopi-components/hooks/useMatchParams";

import { useGlobalsContext } from "kw/util/Globals";

export function useEditCoverSection({ coverSection = {}, prefix }) {
  const navigate = useNavigate();
  const globalDataKey = useGlobalsContext();
  const [, setData] = useGlobal(globalDataKey);
  const { coverId } = useMatchParams(`${prefix}/cover/:coverId/:questionSetKey`);
  const orderedQuestionSets = coverSection?.coverQuestionSets
    ?.map(({ questionSet }) => questionSet)
    .sort((a, b) => a.order - b.order);
  const id = coverSection?.id;
  const updating = id && coverId === id;
  const openFirstQuestionSet = () => {
    setData({ isCoverFlow: true });
    navigate(`${prefix}/cover/${id}/${orderedQuestionSets?.[0].key}`, {
      replace: true,
    });
  };
  const goToPrefix = async () => {
    setData({ isCoverFlow: false });
    navigate(`${prefix}`, {
      replace: true,
    });
  };

  return {
    startEditing: id ? openFirstQuestionSet : null,
    exitEditing: goToPrefix,
    updating,
    coverId,
  };
}
